module.exports = __webpack_public_path__ + "img/10_Floor to Pier.3ad51421.png";